import React from 'react'
import styled from 'styled-components'
import { FormGroup } from 'reactstrap'

import theme from 'vars/theme'
import arrowDown from 'assets/svgs/arrow-down.svg'
import arrowLeft from 'assets/svgs/arrow-left.svg'
import arrowRight from 'assets/svgs/arrow-right.svg'
import calendar from 'assets/svgs/calendar.svg'
import clock from 'assets/svgs/clock.svg'

const FormWrapper = styled(({ isError, isHightLight, ...props }) => <FormGroup {...props} />)`
  display: flex;
  width: ${(props) => props.width || '100%'};

  .form-check-input {
    position: relative;
    margin: 0 0.5rem 0.25rem 0;
  }

  &.form-check {
    padding-left: 0;
    position: relative;
    padding-left: 24px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    label {
      cursor: pointer;
      color: ${({ isHightLight }) => (isHightLight ? theme.blueMedium2 : '')};
    }

    input[type="checkbox"] {
      appearance: none;
      margin: 0;
      position: absolute;
      top: 3px;
      left: 0;
      height: 18px;
      width: 18px;
      border: 1px solid ${theme.blueSoft1};
      border-radius: 2px;
      background-color: ${theme.blueSoft2};
      cursor: pointer;
    }

    /* On mouse-over, add a hover background color */
    .form-check-label:hover input[type="checkbox"]:not(:checked) {
      background-color: ${theme.blueSoft1};
    }

    /* When the checkbox is checked, add a blue background */
    input[type="checkbox"]:checked {
      background-color: ${theme.bluePrimary};
      border: 1px solid ${theme.bluePrimary};
      border-radius: 2px;
    }

    /* Show the checkmark when checked */
    input[type="checkbox"]:checked::after {
      display: block;
      content: "";
      position: absolute;
      left: 6px;
      top: 2px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    label:has(input[type="checkbox"]:disabled) {
      cursor: not-allowed;
    }

    input[type="checkbox"]:disabled {
      cursor: not-allowed;
      background: ${theme.graySoft4};
      border-color: ${theme.blueSoft1};
      &:hover {
        background: ${theme.graySoft4} !important;
      }
    }
  }

  .form-control {
    font-size: 14px;
    color: ${theme.darkBlueMedium1};
    border: 1px solid;
    border-color: ${({ isError }) => (isError ? theme.redMedium1 : theme.graySoft2)};

    &[type="text"]:disabled  {
      -webkit-text-fill-color: #495057;
    }

    &:not(:only-child) {
      margin-right: 16px;
    }

    &::-webkit-input-placeholder {
      font-size: 14px;
      color: ${theme.grayMedium1};
    }

    &[type='time'] {
      background: url(${clock}) no-repeat scroll;
      background-position: right 7px top 5px;
      padding-right: 30px;

      &:not(:only-child) {
        margin-right: 25px;
      }
    }

    &:focus:not(:disabled),
    &:hover:not(:disabled) {
      border-color: ${theme.bluePrimary};
      box-shadow: 0 0 0 1px ${theme.bluePrimary};
    }
  }

  select.form-control {
    padding: 0 12px;
    background: url(${arrowDown}) no-repeat;
    background-position: right 7px top 5px;
    -webkit-appearance: none;

    &:disabled,
    &[readonly] {
      background: ${theme.grayPrimary};
      cursor: not-allowed;
    }
  }

  .DayPickerInput {
    width: 100%;
    margin-left: 0.25rem;

    &:not(:only-child) {
      margin-right: 0.25rem;
    }

    input {
      width: 100%;
      height: calc(2rem + 6px);
      border-radius: 4px;
      outline: none;
      color: ${theme.darkBlueMedium1};
      border: 1px solid ${theme.graySoft2};
      border-color: ${(props) => (props.isError ? theme.redMedium1 : '')};
      padding-left: 12px;
      background: url(${calendar}) no-repeat scroll;
      background-position: right 7px top 5px;
      cursor: pointer;

      &::-webkit-input-placeholder {
        font-size: 14px;
        color: ${theme.grayMedium1};
      }

      &:focus:not(:disabled),
      &:hover:not(:disabled) {
        border-color: ${theme.bluePrimary};
        box-shadow: 0 0 0 1px ${theme.bluePrimary};
      }

      &:disabled {
        background-color: ${theme.graySoft5};
      }
    }
  }

  .DayPickerInput-Overlay {
    left: auto;
    right: 0;

    &.DayPicker {
      width: 100%;
      font-size: 12px;
    }

    .DayPicker {
      &-Caption {
        text-align: center;

        div {
          font-size: 14px;
        }
      }

      &-NavButton {
        top: 1rem;
        width: 50px;

        &--prev {
          background-image: url(${arrowLeft});
          left: 0;
        }

        &--next {
          background-image: url(${arrowRight});
          right: 0;
        }
      }

      &-Weekday {
        color: ${theme.darkBlueMedium1};
        padding: 6px 8px;
        font-size: 14p;
      }

      &-Day {
        padding: 4px 2px;
        font-size: 12px;

        &:nth-child(1):not(.DayPicker-Day--today) {
          color: ${theme.redMedium1};
        }

        &:nth-child(7):not(.DayPicker-Day--today) {
          color: ${theme.redMedium1};
        }

        &--disabled {
          color: ${theme.grayMedium1} !important;
        }

        &--selected {
          color: white !important;
          background-color: ${theme.blueMedium1};
        }
      }
    }

    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      background-color: ${theme.blueMedium1};

      &:hover {
        background-color: ${theme.bluePrimary};
      }
    }
  }
`

const ErrorText = styled.p`
  width: 100%;
  margin: 0.25rem 0 0 0.5rem;
  font-size: 12px;
  color: ${theme.redMedium1};
`

export { FormWrapper, ErrorText }
